var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doink"},[_c('div',{staticClass:"offline-msg"},[_c('p',{directives:[{name:"t",rawName:"v-t"}]},[_vm._v("Ugh, no internet. You’re in temporary read-only mode.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }